// back compat
import "./joinedPhysicsEngineComponent.js";
import "./v1/physicsEngineComponent.js";
import "./v2/physicsEngineComponent.js";
